import GradientBackground from './GradientBackground'

export default GradientBackground
